export const addProcessing = () => {
  // Return action
  return {
    type: 'ADD_PROCESSING',
//	id: id
    // Payload
  }
};

export const removeProcessing = () => {
  // Return action
  return {
    type: 'REMOVE_PROCESSING',
//	id: id
    // Payload
  }
};